import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { Switch, useLocation, useHistory } from "react-router-dom";
import routerMap from "@icoach/router/routers";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { Box } from "@curves/ui-base";
import { flatDeepArray } from "@util/utils";
import { NotFoundPage, NotFoundPDFPage } from "@error/";
import { getMenusData } from "@redux/menus/selector";
import { localUser, isEmpty, isEqual } from "@util/utils";
import { devRegexList } from "@icoach/constants/appConfig";
import { CLUB_POS_ROUTER, CLUB_INVENTORY_ROUTER } from "@icoach/router/routerPath";
import { developerRouter } from "@icoach/router/DevelopmentRouter";

const EmptyComponent = () => <></>;

const checkRootPath = pathname => pathname === "/club" || pathname === "/club/";

const Main = props => {
	const [isMounted, setMounted] = useState(false);
	const menuData = useSelector(getMenusData);
	const { path: rootPath, className: classNameProps } = props;
	const { pathname } = useLocation();
	const history = useHistory();
	const hostname = window.location.hostname;

	const devPrivateRoute = useMemo(
		() => {
			const { hostname } = window.location;
			if (devRegexList.some(regex => regex.test(hostname))) {
				const devRouters = flatDeepArray([developerRouter]);
				return devRouters.reduce((acc, { path: path__, as: as__, ...others }) => {
					let sourceAry = [...acc];
					if (path__) {
						sourceAry.push(<PrivateRoute key={path__} path={path__} as={as__} {...others} />);
					}
					return sourceAry;
				}, []);
			} else {
				return null;
			}
		},
		// eslint-disable-next-line
		[],
	);

	useEffect(
		() => {
			if (!isEmpty(menuData) && !isEmpty(menuData.oriMenuData)) {
				setMounted(true);
			}
			return () => setMounted(false);
		},
		// eslint-disable-next-line
		[menuData],
	);

	useEffect(
		() => {
			const { clubSystemType = "" } = localUser.get() || {};
			if (checkRootPath(pathname) && clubSystemType) {
				isEqual(clubSystemType, 3) ? history.push(`${rootPath}/home/arrive/`) : history.push(`${rootPath}/points/points-redeem/overview/`);
			}
		},
		// eslint-disable-next-line
		[pathname],
	);

	// 另外分頁無需在渲染右邊內容
	const posRegex = new RegExp(`^${CLUB_POS_ROUTER.BASE}.*`);
	const clubInventoryRegex = new RegExp(`^${CLUB_INVENTORY_ROUTER.BASE}.*`);
	if (posRegex.test(pathname) || clubInventoryRegex.test(pathname)) return null;

	return (
		<Box className={classNameProps}>
			{isMounted && (
				<Switch>
					{routerMap["club"].map(({ frontKey, path: pathRouter, exact, as: Component, ...others }, _index) => {
						if (!pathRouter) return null;
						const defaultProperty = {
							path: pathRouter,
							exact,
							as: Component,
							...others,
						};
						let isExist = menuData.menulist.find(({ frontKey: _key }) => isEqual(frontKey, _key));

						if (/^CXX99[\d]+$/g.test(frontKey) && isEqual(hostname, "localhost")) {
							isExist = {}; //專門給正在開發且測試的頁面使用
						}

						if (isEqual(frontKey, "CXX99901")) {
							isExist = {};
						}

						if (isEqual(frontKey, "CXX99902")) {
							isExist = {}; // POS 系統頁面，暫時不受權限控管
						}

						return isExist ? <PrivateRoute key={`${frontKey}_${_index}`} {...defaultProperty} isAuth={isExist.isAuth} /> : null;
					})}
					{devPrivateRoute}
					{/*   Todo   */}
					<PrivateRoute path={`${rootPath}/404`} as={NotFoundPage} />
					<PrivateRoute path={`${rootPath}/pdf-notfound`} as={NotFoundPDFPage} />
					<PrivateRoute path="*" as={checkRootPath(pathname) ? EmptyComponent : NotFoundPage} />
				</Switch>
			)}
		</Box>
	);
};

export default Main;
